// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import { DefaultProps, defaultConnect } from './base';
import ReportIAPPanel from '../ReportIAPPanel';
import { ContentType } from '../submit/SubmitIapVote';

import type { ContentProps, InternalProps } from './base';
import type { ForumInfo } from '../submit/SubmitIapVote';

type ForumProps = {
  ...ContentProps,
  forumInfo?: ForumInfo,
};
export type InternalForumProps = {
  ...ForumProps,
  ...InternalProps,
};

const ReportForumPanel = ({ forumInfo, ...props }: InternalForumProps) => (
  <ReportIAPPanel
    csrfToken={props.csrfToken}
    userId={props.userId}
    // $FlowFixMe contentId is fine, I'm not sure what you're so mad about.
    contentId={props.contentId}
    contentType={ContentType.FORUM}
    onError={props.onError}
    onComplete={props.onComplete}
    forumInfo={forumInfo}
    repostInfo={props.repostInfo}
  >
    {panel => (
      <React.Fragment>
        {panel.createRadioWithOptionalComment('SELF_PROMOTION_ADVERTISEMENT_SOLICITATION')}
        {panel.createRadioWithOptionalComment('OFF_TOPIC')}
        {panel.createRadioWithOptionalComment('SPAM')}
        {panel.createRadioWithOptionalComment('DUPLICATE_FORUM')}
        {panel.createRadioWithOptionalComment('HARASSMENT')}
        {panel.createRadioWithOptionalComment('PROFANITY_SEX_VIOLENCE_CRIME_HATE')}
        {panel.createRadioWithOptionalComment('MULTIPLE_ACCOUNTS_OR_IMPERSONATION')}
        {panel.createRadioWithOptionalComment('PERSONAL_INFO')}
        {panel.createRadioWithOptionalComment('COPYRIGHTED')}
      </React.Fragment>
    )}
  </ReportIAPPanel>
);
ReportForumPanel.defaultProps = DefaultProps;

// $FlowFixMe92
export default connect(state => defaultConnect(state))(ReportForumPanel);
